import React, { useState, useEffect } from 'react';
import { categoryApi } from '../../services/productApi';

const CategorySelector = ({ setProductData , selectedCategory, onCategoryChange }) => {
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearchOption, setShowSearchOption] = useState(false)
  const [showSelectedCategory, setShowSelectedCategory]=useState(!!selectedCategory)

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    setShowSelectedCategory(!!selectedCategory);
  }, [selectedCategory]);

  const fetchCategories = async () => {
    try {
      const response = await categoryApi.getLeaves();
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const filteredCategories = categories.filter(category =>
    category.name.includes(searchTerm) ||
    category.full_path?.includes(searchTerm)
  );

    const handleClearSelection = () => {
    onCategoryChange(null); // یا '' بسته به نوعی که انتظار دارید
    setSearchTerm('');
    setShowSelectedCategory(false);
    setProductData(prev => ({
                              ...prev,
                              category: '',
                              attributes:{},
                          }));
  };

  return (
    <div className="relative">
      <input
        type="text"
        placeholder="جستجو در دسته‌ها..."
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setShowSearchOption(true)
        }}

        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      {searchTerm && showSearchOption && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
          {filteredCategories.map(category => (
            <div
              key={category.id}
              onClick={() => {
                // فقط ID دسته‌بندی رو بفرست
                onCategoryChange(category.id);
                setSearchTerm('');
                setShowSearchOption(false)
                setShowSelectedCategory(true)
              }}
              className="px-4 py-2 cursor-pointer hover:bg-gray-100 border-b border-gray-100"
            >
              <div className="font-medium">{category.name}</div>
              <div className="text-sm text-gray-500">{category.full_path}</div>
            </div>
          ))}
        </div>
      )}

      {showSelectedCategory && selectedCategory && (
          <div className="mt-2 p-3 bg-[#f5f5f5] rounded-md flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-[#254774] font-[18]">دسته انتخاب شده:</span>
              <span className="text-[#1E3A5F]">
      {categories.find(cat => cat.id === selectedCategory)?.name || selectedCategory}
    </span>
          </div>
            <button
                onClick = {handleClearSelection}
                className="text-[#1E3A5F] hover:text-[#D19D00] hover:bg-[#1D7D74] p-1 rounded-full transition-colors duration-200"
                title="پاک کردن"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
      )}
    </div>
  );
};

export default CategorySelector;